import jsPDF from 'jspdf';
import Logo from '../../images/AOCLogo.png';
import imgmitch from '../../images/imgmitch.png';
import imgwyong from '../../images/imgwyong.png';
import { dateFormatZeros, isDate, undoDateFormat } from '../dateFunctions';
import { getAPIDataReturn } from '../apiFunction';
import { getPRNfrmLSN } from '../fulfilment/lsnFunction';

const hasAddress = (address) => Boolean(address && (address.line1 || address.line2 || address.city || address.state || address.postcode));

const getPreferredShippingAddress = (salesOrderAddress, customerAddress) => {
  if (hasAddress(salesOrderAddress)) {
    return salesOrderAddress;
  }

  return customerAddress || {};
};

// Best Before logic: modal only = print date + 1 year; others = existing rule
function computeBestBefore(extra) {
  if (extra?.context === 'frozen_labeler') {
    const d = new Date(extra?.printDate || Date.now());
    d.setFullYear(d.getFullYear() + 1);
    return d;
  }
  const d = new Date();
  d.setMonth(d.getMonth() + 13);
  d.setDate(1);
  return d;
}

export const saveLabel = async (detailsList, saleItem, codeInfo, halfshell, forceUnits, comboPRN, extra) => {
  const isFrozen = codeInfo.isFrozen;
  const isPacific = codeInfo.isPacific;
  const isPopped = codeInfo.isPopped;
  const isLidOff = codeInfo.isLidOff;
  const isOS = codeInfo.isOysterSmiths;
  const shippingAddress = getPreferredShippingAddress(saleItem?.shippingAddress, saleItem?.customer?.shippingAddress);

  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: [160, 110],
  });

  const getProduct = (spec, half) => {
    let out = '';
    switch (spec) {
      case 'PC': out = 'Pacific'; break;
      case 'SR': out = 'Sydney Rock'; break;
      case 'AN': out = 'Angasi'; break;
      default: out = 'Oyster';
    }
    return (isOS ? 'OS ' : '') + out + ' ' + (half ? (isPopped ? 'Popped' : (isLidOff ? 'Lid Off' : 'Halfshell')) : (isFrozen ? 'FROZEN' : 'Live'));
  };

  const ifUndef = (v) => (v ? v : '');

  const fontSml = 12;
  const fontOne = 20;
  const fontTwo = 20;
  const fontThree = 24;

  const Logoi = new Image();
  Logoi.src = Logo;

  const lineWidth = 8;

  for (let j = 0; j < detailsList.length; j++) {
    const details = detailsList[j];

    let estuary = details?.ivn?.estuary;
    if (!estuary) estuary = details?.newIvn?.estuary?.description;

    let loops = details.units ? details.units : (details.quantity / (codeInfo.bagCount ? codeInfo.bagCount : 1));
    if (loops === 0) loops = 1;

    for (let i = 0; i < loops; i++) {
      let line = 5;
      if (!((i === 0) && (j === 0))) doc.addPage();

      doc.setTextColor('#000');
      doc.setFontSize(8);
      doc.addImage(Logoi, 'PNG', 120, line, 40, 35);
      doc.text('8 Sheridan Cl, Milperra NSW', 122, line + 37);
      doc.text('Lic: 51487', 145, line + 40);
      doc.setFontSize(fontSml);
      line += 5;
      console.log(saleItem)
      if (!saleItem?.customer?.name?.includes("Australia's Oyster Coast")) {
        // Deliver To
        if (extra?.context === 'frozen_labeler') {
          // modal-only: skip address lines
          doc.text('Deliver To:' + (extra?.customerPO ? ('  ' + ifUndef(extra?.customerPO)) : ''), 2, line);
          line += lineWidth * 2;
        } else {
          // NON-FROZEN: wrap long lines to keep clear of the logo/header at x≈110
          doc.text('Deliver To:' + (extra?.customerPO ? ('  ' + ifUndef(extra?.customerPO)) : ''), 2, line);
          doc.setFontSize(fontTwo);
          line += lineWidth;

          // left column and width (stop ~2mm before header text at x=110)
          const LEFT_X = 2;
          const RIGHT_GUTTER_X = 108;
          const MAX_LEFT_WIDTH = RIGHT_GUTTER_X - LEFT_X;

          // helper: wrap text to left column and advance line accordingly
          const writeWrap = (txt, shrinkForLong = false, truncate = false) => {
            var s = ifUndef(txt);
            if (!s) return;
            console.log('wrapping:', s.length);
            var lineAdj = 0;
            if (shrinkForLong && s.length > 35) {
              doc.setFontSize(fontTwo - 3);
              lineAdj = 1;
            }
            if (truncate && s.length > 75) {
              s = s.substring(0, 72) + '...';
            }
            const wrapped = doc.splitTextToSize(s, MAX_LEFT_WIDTH);
            doc.text(wrapped, LEFT_X, line);
            line += wrapped.length * (lineWidth - lineAdj);
            doc.setFontSize(fontTwo); // reset in case we shrank
          };

          // Customer name (slightly shrink if very long), then address lines
          writeWrap(saleItem?.customer?.name, true);
          writeWrap(shippingAddress?.line1, true, true);
          writeWrap(shippingAddress?.line2, true, true);

          const cityStatePost = [
            shippingAddress?.city,
            shippingAddress?.state,
            shippingAddress?.postcode,
          ].filter(Boolean).join(' ');
          writeWrap(cityStatePost);
        }
      }

      line += lineWidth / 2 - 3;
      console.log(line)
      // ✅ Ensure body starts below logo/address block
      const HEADER_FLOOR = 54;
      if (line < HEADER_FLOOR) line = HEADER_FLOOR;

      // Product
      doc.setFontSize(fontTwo);
      const xSecond = 60;
      doc.text('Product: ', 2, line);
      doc.text((getProduct(codeInfo.species.code, halfshell) + (codeInfo?.description?.includes('LID OFF') ? ' LID OFF' : '')), xSecond, line);
      line += lineWidth;

      // Size (black bar)
      doc.setFontSize(fontOne);
      doc.text('Size: ', 2, line);
      // doc.setFillColor('#000000');
      // doc.setTextColor('#fff');
      // doc.rect(xSecond, line - 7, 160 - xSecond, 9, 'F');
      doc.setFont(undefined, 'bold');
      let sizeText;
      if (saleItem?.customer?.name === 'Foodlink Australia PTY LTD') {
        const gradeFlip = {
          Cocktail: 'Bistro',
          Bistro: 'Large',
          Plate: 'Extra Large',
          Buffet: 'Large (Buffet)',
          Standard: 'Extra Large',
        };
        sizeText = gradeFlip[codeInfo.grade?.description] ? gradeFlip[codeInfo.grade?.description] : codeInfo.grade?.description;
      } else {
        sizeText = codeInfo.grade?.description;
      }
      doc.text(sizeText, xSecond, line);
      const textWidth = doc.getTextWidth(sizeText);
      doc.setDrawColor('#000');
      doc.setLineWidth(0.5);
      doc.line(xSecond, line + 1.5, xSecond + textWidth, line + 1.5);
      doc.setFont(undefined, 'normal');
      doc.setTextColor('#000');
      line += lineWidth;

      // Estuary
      doc.setFontSize(fontOne);
      doc.text('Estuary: ', 2, line);
      doc.setFontSize(fontOne);
      if (comboPRN) {
        const estuaryString = comboPRN.reduce((p, c) => {
          const currEst = c.pn.ivn?.estuary ? c.pn.ivn?.estuary : c.pn.newIvn?.estuary?.description;
          if (p.includes(currEst)) return p;
          return (p === '' ? p : (p + ', ')) + ifUndef(currEst);
        }, '');
        doc.setFontSize((fontThree + 10) - (estuaryString.length / 2));
        doc.text(ifUndef(estuaryString), xSecond, line);
      } else {
        doc.text(ifUndef(estuary), xSecond, line);
      }

      doc.setFontSize(fontTwo);
      line += lineWidth;

      // Dates
      doc.setFontSize(fontTwo);
      if (halfshell) {
        doc.text('Use By Date: ', 2, line);
        if (comboPRN) {
          const oldest = comboPRN.reduce((a, b) =>
            new Date(a.pn.ivn?.expiryDate) < new Date(b.pn.ivn?.expiryDate) ? a : b
          );
          doc.text(dateFormatZeros(oldest.pn.ivn?.expiryDate), xSecond, line);
        } else {
          doc.text(dateFormatZeros(details.ivn?.expiryDate), xSecond, line);
        }
      } else {
        if (isFrozen) {
          doc.text('Best Before: ', 2, line);
          const bestBefore = computeBestBefore(extra);
          doc.text(dateFormatZeros(bestBefore), xSecond, line);
        } else {
          doc.text('Harvest Date: ', 2, line);
          doc.text(
            (details.ivn?.harvestDate?.includes('T') ? dateFormatZeros(details.ivn?.harvestDate) : details.ivn?.harvestDate),
            xSecond, line
          );
        }
      }

      doc.setFontSize(fontTwo);
      line += lineWidth;

      // PRN
      doc.text('PRN: ', 2, line);
      if (comboPRN) {
        doc.setFontSize(fontTwo - (comboPRN.length + 1));
        if (comboPRN.length > 5) doc.setFontSize(fontTwo - (comboPRN.length + 2));
        doc.text(String(comboPRN.reduce((p, c) => {
          if (p === '') return getPRNfrmLSN(c.pn.ivn?.lotSerialNbr);
          return p + '/' + getPRNfrmLSN(c.pn.ivn?.lotSerialNbr);
        }, '')), xSecond, line, { maxWidth: 99 });
      } else {
        doc.text(String(getPRNfrmLSN(details.ivn?.lotSerialNbr)), xSecond, line);
      }

      doc.setFontSize(fontTwo);
      line += lineWidth + 2;

      // QTY
      doc.text('QTY:(DOZEN) ', 2, line);
      if (comboPRN) {
        let totalVal = 0;
        const calcString = comboPRN.reduce((p, c) => {
          totalVal += Number(c.quantity);
          return (p === '' ? p : (p + ' + ')) + ifUndef(String(c.quantity));
        }, '');
        if (calcString.length > 22) {
          doc.setFontSize(fontTwo - Math.pow(1.9, calcString.length - 22));
        }
        doc.text(calcString + ' = ' + String(totalVal), xSecond, line);
      } else {
        doc.text(String(forceUnits ? forceUnits : (codeInfo.bagCount ? codeInfo.bagCount : 1)), xSecond, line);
      }

      // contains
      doc.setFontSize(fontSml);
      doc.text('Contains:', xSecond + 60, line);
      doc.setFont(undefined, 'bold');
      doc.text('Molluscs', xSecond + 79, line);
      doc.setFont(undefined, 'normal');

      line += lineWidth;
      line += 2;

      // footer bar
      doc.setFontSize(fontThree);
      doc.setTextColor('#000');
      doc.setDrawColor('#000');

      if (halfshell || (isPacific && !isFrozen)) {
        // doc.rect(0, line - 8, 160, 10, 'F');
        doc.text('Please keep below 5 C', 30, line);
        doc.setLineWidth(0.7);
        doc.circle(110, line - 5, 1);
      } else if (isFrozen) {
        doc.setFontSize(10);
        // doc.rect(0, line - 8, 160, 10, 'F');
        doc.text('Store frozen oysters below -18 C', 2, line - 5);
        doc.text('Refrigerate to thaw, do not refreeze, store below 4 C and consume within 3 days', 2, line - 1);
        doc.setLineWidth(0.2);
        doc.circle(50, line - 7, 0.4);
        doc.circle(81, line - 3.5, 0.4);
      }

      if (forceUnits) i = loops;
    }
  }

  doc.autoPrint();
  window.open(doc.output('bloburl'), '_blank', 'height=800,width=800');
};

export const saveWLabel = async (details, saleItem, site, fourUp = false) => {
  if (!details?.ivn?.lotSerialNbr) return;

  const orderDateRaw =
    saleItem?.orderDate ||
    saleItem?.date ||
    saleItem?.dateCreated ||
    saleItem?.createdDate ||
    saleItem?.salesOrder?.date ||
    Date.now();

  const orderDate = new Date(orderDateRaw);
  const safeOrderDate = Number.isNaN(orderDate.getTime()) ? new Date() : orderDate;
  const useByDate = new Date(safeOrderDate);
  useByDate.setDate(useByDate.getDate() + 7);

  const ims = new Image();
  ims.src = site === 'WYONG' ? imgwyong : imgmitch;
  var isWyong = site === 'WYONG';

  const prnText = String(getPRNfrmLSN(details.ivn.lotSerialNbr));
  const orderDateText = dateFormatZeros(safeOrderDate);
  const useByText = dateFormatZeros(useByDate);

  const drawWLabel = (doc, x, y, w, h) => {
    const sx = w / 110;
    const sy = h / 160;
    const sf = Math.min(sx, sy);

    doc.addImage(ims, 'PNG', x + (4 * sx), y + (4 * sy), 110 * sx, 160 * sy);
    doc.setTextColor('#000');
    doc.setFontSize(15 * sf);

    doc.text(prnText, x + ((isWyong ? 29 : 32) * sx), y + (42 * sy));
    doc.text(orderDateText, x + (34 * sx), y + ((isWyong ? 56 : 55) * sy));
    doc.text(useByText, x + ((isWyong ? 27 : 30) * sx), y + ((isWyong ? 62 : 61) * sy));
  };

  let doc;
  if (fourUp) {
    doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

    const labelW = 99.1;
    const labelH = 139;
    const marginX = (210 - (labelW * 2)) / 2;
    const marginY = (297 - (labelH * 2)) / 2;

    drawWLabel(doc, marginX, marginY, labelW, labelH);
    drawWLabel(doc, marginX + labelW, marginY, labelW, labelH);
    drawWLabel(doc, marginX, marginY + labelH, labelW, labelH);
    drawWLabel(doc, marginX + labelW, marginY + labelH, labelW, labelH);
  } else {
    doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [160, 110],
    });

    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    drawWLabel(doc, 0, 0, pageW, pageH);
  }


  doc.autoPrint();
  window.open(doc.output('bloburl'), '_blank', 'height=800,width=800');
};
